import React, { Component } from "react";
import { connect } from "react-redux";
import disableBrowserBackButton from "disable-browser-back-navigation";
import Modal from "react-bootstrap/Modal";
import xss from "xss";

import { Link, useNavigate } from "../utils/components/router";
import { kundenActions, authActions, configActions } from "../actions";
import { YES_RESPONSE_STATUS } from "../utils/enums/YES_RESPONSE_STATUS";
import { storeDataForYesLogin, postYesLogin } from "../utils/functions/handleYesLogin";
import CONFIG from "../config";
import { RESPONSE_HEADER } from "../utils/enums";

class Login extends Component {
  state = {
    data: [],
    redirect: false,
    yesRequested: false,
  };

  componentDidMount() {
    disableBrowserBackButton();
    this.makeInitialYesCall();
  }

  async makeInitialYesCall() {
    const data = await storeDataForYesLogin();
    if (data) {
      this.setState({ data, redirect: true });
    } else {
      this.setState({ yesRequested: true });
      const yesResponse = await postYesLogin();
      this.handleYesResponse(yesResponse);
    }
  }

  async directToAddress(yesResponse) {
    if (!yesResponse || !yesResponse.data) {
      this.showWarning("Keine Daten erhalten");
      return;
    }
    let kundenId = yesResponse.data.kundenId;
    this.props.dispatch(kundenActions.setKundenId(kundenId));
    this.props.dispatch(authActions.signIn(kundenId));
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry));
    this.props.navigate(CONFIG.LINK_MITARBEITER_ADD_KUNDEN);
  }

  showWarning(warning) {
    this.setState({ showErrorMsg: true, warningMsg: warning, yesRequested: false });
    this.makeInitialYesCall();
  };

  handleYesResponse(yesResponse) {
    let warning = "";
    if (!yesResponse || !yesResponse.data) {
      this.props.navigate("/error", { errorMsg: "Es ist ein unbekannter Fehler aufgetreten." });
      return;
    }
    this.props.dispatch(configActions.restartSession(this.props.configStorage.getRequestData("session_ping")));
    switch (yesResponse.data.responseStatus) {
      case YES_RESPONSE_STATUS.LOGGED_ON:
        this.directToAddress(yesResponse);
        break;
      case YES_RESPONSE_STATUS.NOT_LOGGED_ON:
      case YES_RESPONSE_STATUS.UNKNOWN:
        warning = "Für den Bestellprozess ist eine Übergabe der Kundendaten notwendig.";
        this.showWarning(warning);
        break;
      case YES_RESPONSE_STATUS.SELECT_ANOTHER_BANK:
        warning = "Leider ist eine Auswahl einer anderen Bank nicht möglich.";
        this.showWarning(warning);
        break;
      default:
        const errorMsg = yesResponse.data.header ? yesResponse.data.header.errorMsg : yesResponse.data.yesErrorDescription;
        this.props.navigate("/error", { errorMsg: xss(errorMsg) || "Es ist beim Bearbeiten des Logins ein unbekannter Fehler aufgetreten." });
        break;
    }
  };

  async redirectToYes() {
    if (this.state.redirect && this.state.data && this.state.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
      this.setState({ yesRequested: true });
      if (this.state.data.sessionData) {
        Object.keys(this.state.data.sessionData).forEach(key => {
          localStorage.setItem(key, JSON.stringify(this.state.data.sessionData[key]));
        });
      }
      return window.location.assign(this.state.data.authenticationRequestUrl);
    }
  };

  render() {
    if (this.state.yesRequested) {
      return (
        <div className="if6_outer section if6_section">
          <div className="bootstrap-iso">
            <div className="container bg-white pt-one h-100">
              <div className="row">
                <div className="col-12 justify-content-center">
                  <div className="col-12 col-md-8 col-lg-6 text-center modal-redirect info">
                    <div className="">
                      <h3 className="text-secondary">
                        Sie werden weitergeleitet
                      </h3>
                    </div>
                  </div>
                </div>
              </div>{" "}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="if6_outer section if6_section">
          <div className="bootstrap-iso">
            <div className="container p-one h-100">
              <Modal.Dialog size="lg">
                <Modal.Header>
                  <h3 className="yeslogin col-12 text-secondary">
                    <span className="volksbank-only">
                      Für Ihre Bestellung ist eine sichere Identifikation erforderlich.
                    </span>
                    <span className="dkb-only">
                      Für Ihren Einkauf ist eine Verifizierung mithilfe Ihres Online-Banking-Logins erforderlich.
                    </span>
                  </h3>
                </Modal.Header>
                <Modal.Body>
                  <div className="volksbank-only">
                    Kunden teilnehmender Volks- und Raiffeisenbanken können sich zu jeder Zeit schnell und bequem
                    über den Login in ihr Online-Banking-Konto identifizieren.
                  </div>
                  <div className="col-12">
                    {this.state.showErrorMsg ?
                      <div className="ui error message text-danger">
                        <div className="header">{this.state.warningMsg}</div>
                      </div> : ""}
                  </div>
                  <div className="col-12 justify-content-center mt-one">
                    <button
                      className="btn btn-default col-6 col-lg-4 text-center"
                      onClick={this.redirectToYes.bind(this)}
                      disabled={!this.state.redirect}
                      id="admin-btn"
                      // data-bs-toggle="modal"
                      data-bs-target="#flipFlopp"
                    >
                      Weiter zu meinem Online-Banking
                    </button>
                  </div>
                </Modal.Body>
                <Modal.Footer className="dkb-only">
                  <div className="col-xs-12 mt-one">
                    <p>
                      Sofern Sie kein Nutzerkonto mit geprüften Daten bei CRIF RealTime Ireland Limited („CRIF“) verfügen,
                      wird CRIF einmalig eine Videoidentifikation durchführen und Ihnen die Anlage eines Identity-Passes ermöglichen.
                      Der Identity-Pass ist Ihr digitales und verifiziertes Datenprofil, mit dem Sie im Internet Ihre Identität nachweisen können.
                    </p>
                    <p>
                      Sie verlassen den Webshop der DKB AG und werden an CRIF weitergeleitet.
                      Für die erfolgreiche Ausführung Ihrer Bestellung ist es erforderlich, dass CRIF geprüfte personenbezogene Daten an uns übermittelt.
                    </p>
                    <p>
                      Erst auf Ihre ausdrückliche Veranlassung wird CRIF Ihre personenbezogenen Daten übermitteln.
                      Anschließend werden Sie zum Webshop der DKB AG zurückgeleitet.<br />
                      Weitere Informationen entnehmen Sie bitte den Datenschutzhinweisen auf der Homepage von CRIF.
                    </p>
                  </div>
                </Modal.Footer>
              </Modal.Dialog>
              <div className="mb-one mt-one">
                <Link
                  to={this.props.configStorage.getBackToShopLink()}
                  className="btn btn-info col-6 col-md-4 col-lg-2">
                  Zurück zum Shop
                </Link>
                <div className="col-lg-7"></div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <Login navigate={contextNavigate} {...props} />;
});
